module.exports = __webpack_public_path__ + "static/media/x-circle-blue.75716459.svg";